import { render } from "./PublishTruck.vue?vue&type=template&id=65792476"
import script from "./PublishTruck.vue?vue&type=script&lang=js"
export * from "./PublishTruck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__